function b64ToUint8Array(value) {
  const padding = '='.repeat((4 - (value.length % 4)) % 4);
  const base64 = (value + padding).replace(/-/g, '+').replace(/_/g, '/');
  const raw = atob(base64);
  return Uint8Array.from([...raw].map((c) => c.charCodeAt(0)));
}

export function pushSupported() {
  return 'serviceWorker' in navigator && 'PushManager' in window && 'Notification' in window;
}

export async function subscribePush(wsClient) {
  if (!pushSupported()) throw new Error('Notifications push non prises en charge sur cet appareil.');
  const permission = Notification.permission === 'granted'
    ? 'granted'
    : await Notification.requestPermission();
  if (permission !== 'granted') throw new Error('Autorisation de notification refusée.');
  const registration = await navigator.serviceWorker.ready;
  const keyRes = await fetch('/api/push/public-key', { cache: 'no-store' });
  if (!keyRes.ok) throw new Error('Service push indisponible.');
  const { publicKey } = await keyRes.json();
  let sub = await registration.pushManager.getSubscription();
  if (!sub) {
    sub = await registration.pushManager.subscribe({
      userVisibleOnly: true,
      applicationServerKey: b64ToUint8Array(publicKey),
    });
  }
  wsClient.pushSubscribe(sub.toJSON());
  return true;
}

export async function unsubscribePush(wsClient) {
  if (!pushSupported()) return;
  const registration = await navigator.serviceWorker.ready;
  const sub = await registration.pushManager.getSubscription();
  if (sub) {
    wsClient.pushUnsubscribe(sub.endpoint);
    await sub.unsubscribe();
  }
}
